"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionGroupImpl_1 = require("./ActionGroupImpl");
function defineActionGroup(typePrefix) {
    return new ActionGroupImpl_1.ActionGroupImpl(typePrefix);
}
exports.defineActionGroup = defineActionGroup;
//# sourceMappingURL=defineActionGroup.js.map